window.VegasJs = {
	init: function () {
		this.viewSection();
	},

	getElement: function (tariffs) {
		let el;
		if (tariffs.indexOf('.') === -1) {
			el = document.getElementById(tariffs);
			if (el === null || el === undefined) {
				return
			}
		} else if (tariffs.indexOf('.') !== -1) {
			el = document.querySelector(tariffs);
			if (el === null || el === undefined) {
				return
			}
		}
		return el;
	},

	viewSection: () => {
		let tariffs = VegasJs.getElement('tariffs');
		let discount = VegasJs.getElement('.page-home--courses .discount-area');
		let learn = VegasJs.getElement('.page-home--learn');
		let carpark = VegasJs.getElement('.page-home--carpark');
		let question = VegasJs.getElement('.questions');
		let car = VegasJs.getElement('.page-home--learn .car');
		let reviews = VegasJs.getElement('.reviews');

		function getCoordinate(section) {
			return section.getBoundingClientRect().y;
		}

		window.addEventListener('scroll', () => {
			if(tariffs === null || tariffs === undefined) {
				return
			}
			if (getCoordinate(tariffs) <= 300) {
				tariffs.classList.add('active');
			}
			if (getCoordinate(tariffs) <= -50) {
				discount.classList.add('active');
			}
			if (getCoordinate(carpark) <= 400) {
				carpark.classList.add('active')
			}
			if (getCoordinate(question) <= 300) {
				question.classList.add('active')
			}
			if (getCoordinate(reviews) <= 300) {
				reviews.classList.add('active')
			}

			if (getCoordinate(tariffs) <= 800) {
				let scroll = getCoordinate(learn);
				if(window.innerWidth > 1600) {
					car.style.cssText = `transform: translate(${scroll - 280}px, ${(scroll - 840) / 2}px);`;
				} else if(window.innerWidth < 1600 && window.innerWidth > 1200) {
					car.style.cssText = `transform: translate(${scroll - 280}px, ${(scroll - 760) / 2}px);`;
				} else {
					car.style.cssText = `transform: translate(${scroll - 280}px, ${(scroll - 750) / 2}px);`;
				}
			} else if(getCoordinate(tariffs) >= 300) {
				car.style.cssText = ``;
			}
		})
	}
};

VegasJs.init();
